import { render } from "./VODVideoModal.vue?vue&type=template&id=2ee23d24&scoped=true"
import script from "./VODVideoModal.vue?vue&type=script&lang=js"
export * from "./VODVideoModal.vue?vue&type=script&lang=js"

import "./VODVideoModal.vue?vue&type=style&index=0&id=2ee23d24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee23d24"],['__file',"src/components/modals/VODVideoModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ee23d24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ee23d24', __exports__)) {
    api.reload('2ee23d24', __exports__)
  }
  
  module.hot.accept("./VODVideoModal.vue?vue&type=template&id=2ee23d24&scoped=true", () => {
    api.rerender('2ee23d24', render)
  })

}


export default __exports__